import { Select } from 'antd'
{ Option } = Select
import { useUnstaleCleanup } from 'Hooks'
import { useEffect, useState } from 'react'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import { setEdits, setRelationsMap } from '../SpreadSheetDataProvider/actions'
import { getNodeLabel, getUid } from 'Services/WeaverUtils'
import PermissionsService from 'Services/PermissionsService'
import './RelationCell.scss'

RelationCell = ({ defaultValue = [], r, c }) ->

  [{
    columns,
    edits,
    isEscapingEditMode,
    relationsMap
  }, dispatch] = useSpreadSheetData()

  getDataObjs = (values) ->
    values.map((val) ->
      {
        val,
        label: getNodeLabel(relationsMap[val])
      }
    )

  [values, setValues] = useState(defaultValue)
  [options, setOptions] = useState(getDataObjs(values))
  [loading, setLoading] = useState(false)

  { key, targetValidator, targetLabel } = columns[c].relationConf

  useEffect( ->
    setOptions(
      getDataObjs(
        PermissionsService.filterPermittedTargets(key, _.keys(relationsMap), values)
      )
    )
    undefined
  , [relationsMap])

  useEffect( ->
    setValues(edits[r]?[c]) if edits[r]?[c]
    undefined
  , [edits])

  useUnstaleCleanup( ->
    return if isEscapingEditMode or (values.join(', ') is defaultValue.join(', '))
    localEdits = _.mapValues(edits, (val) -> { val... })
    localEdits[r] ?= {}
    localEdits[r][c] = values

    dispatch(setEdits({
      prevEdits: { edits... }
      nextEdits: { localEdits... }
    }))
  )

  updateSearch = (str) ->
    setLoading(true)
    query = targetValidator(
      PermissionsService.getRelationTargetQuery(key)
    ).contains(targetLabel, str)

    if str.length < 2
      query.limit(50)

    nodeResults = await query.find()

    dispatch(
      setRelationsMap({
        relationsMap...,
        nodeResults.reduce((acc, curr) ->
          { acc..., [getUid(curr)]: curr }
        , {})...
      })
    )
    setLoading(false)

  <Select
    mode="multiple"
    defaultValue={defaultValue}
    value={values}
    style={{ width: '100%' }}
    filterOption={(str, { children }) -> children.indexOf(str) isnt -1}
    placeholder="Select a relation"
    maxTagCount={1}
    onChange={(vals) -> setValues(vals)}
    onFocus={ -> updateSearch('')}
    onSearch={updateSearch}
    loading={loading}
    notFoundContent={null}
    size="small"
    disabled={!columns[c].editFn}
  >
    {options.map(({ val, label }) ->
      <Select.Option value={val} style={{ fontSize: '9pt' }} key={val}>{ label }</Select.Option>
    )}
  </Select>

export default RelationCell
